import { render, staticRenderFns } from "./xiaoqu.vue?vue&type=template&id=c1260566&scoped=true&"
import script from "./xiaoqu.vue?vue&type=script&lang=js&"
export * from "./xiaoqu.vue?vue&type=script&lang=js&"
import style0 from "./xiaoqu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./xiaoqu.vue?vue&type=style&index=1&id=c1260566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1260566",
  null
  
)

export default component.exports